/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { FunctionComponent } from 'react';
import Icon from '../../../DataDisplay/Icon/Icon';

import styles from './MultiSelectedItem.module.scss';

type MultiSelectedItemProps = {
  label: React.JSX.Element | string;
  value: string;
  onDelete: (value: string) => void;
};

type FC = FunctionComponent<MultiSelectedItemProps>;

const MultiSelectedItem: FC = ({ label, value, onDelete }: MultiSelectedItemProps) => (
  <>
    <div className={styles.itemContainer}>
      <span>{label}</span>
      <span
        className={styles.crossContainer}
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          onDelete(value);
        }}
      >
        <Icon icon="cross" height="8px" width="8px" color="medium-grey" />
      </span>
    </div>
  </>
);

export default MultiSelectedItem;
